<div class="bg-th-yellow mt-0 container-fluid">
  <div class="d-flex justify-content-between align-content-center h-35">
    <i class="fa fa-arrow-left text-dark my-auto pointer" routerLink="/"></i>
    <span class="my-auto f16 fw-bold me-2"> نقشه نقاط آبگیری غیر‌مجاز </span>
  </div>
</div>

<div class="modal fade" id="illegal-water-sources-modal" data-backdrop="false" data-bs-backdrop='static' data-bs-keyboard="false">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content dirI">
      <div class="modal-header dirI">
        <h5 class="modal-title" id="exampleModalLabel">انتخاب بازه زمانی</h5>
        <button type="button" class="btn-close"></button>
      </div>
      <div class="modal-body">
        <div [formGroup]="searchForm" class="w-100 form row g-3">
          <div class="col-12">
            <label> از تاریخ </label>

            <ng-persian-datepicker
              [uiTheme]="'gray'"
              [timeEnable]="false"
              [dateGregorianFormat]="'YYYY/MM/DD'"
              [dateInitValue]="true"
              [dateFormat]="'jYYYY/jMM/jDD'"
            >
              <input formControlName="strSDate" class="form-control text-end" />
            </ng-persian-datepicker>
          </div>

          <div class="col-12">
            <label> تا تاریخ </label>

            <ng-persian-datepicker
              [uiTheme]="'gray'"
              [timeEnable]="false"
              [dateGregorianFormat]="'YYYY/MM/DD'"
              [dateInitValue]="true"
              [dateFormat]="'jYYYY/jMM/jDD'"
            >
              <input formControlName="strEDate" class="form-control text-end" />
            </ng-persian-datepicker>
          </div>

          <div class="col-12 col-md-auto">
            <button class="w-100 btn btn-primary" (click)="fetchData()">
              جستجو
            </button>
          </div>
        </div>
      </div>
      <div class="modal-footer"></div>
    </div>
  </div>
</div>
